import { type ItemSectionCreate } from '../../../types'

export const createItemData = (): ItemSectionCreate => ({
  data: null,
  type: 'item',
})
